module.exports = __webpack_public_path__ + "static/media/edu.480c3281.jpg";